document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    console.log('💻 Desenvolvido por Tiago Garcia - (16) 991627898');

    // 1. ÍCONES LUCIDE
    if (typeof lucide !== 'undefined') {
        lucide.createIcons();
    }

    // 2. HEADER SCROLL
    const header = document.getElementById('header');
    if (header) {
        window.addEventListener('scroll', () => {
            if (window.scrollY >= header.offsetHeight) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        }, { passive: true });
    }

    // 3. MENU MOBILE (HAMBURGER)
    const hamburger = document.getElementById('hamburger');
    const mobileNav = document.getElementById('mobile-nav');
    const mobileNavLinks = document.querySelectorAll('.mobile-nav-link');

    if (hamburger && mobileNav) {
        hamburger.addEventListener('click', function () {
            const isActive = hamburger.classList.toggle('active');
            mobileNav.classList.toggle('active', isActive);
            hamburger.setAttribute('aria-expanded', isActive);
            mobileNav.setAttribute('aria-hidden', !isActive);
            document.body.style.overflow = isActive ? 'hidden' : '';
        });

        mobileNavLinks.forEach(function (link) {
            link.addEventListener('click', function () {
                hamburger.classList.remove('active');
                mobileNav.classList.remove('active');
                hamburger.setAttribute('aria-expanded', 'false');
                mobileNav.setAttribute('aria-hidden', 'true');
                document.body.style.overflow = '';
            });
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && mobileNav.classList.contains('active')) {
                hamburger.classList.remove('active');
                mobileNav.classList.remove('active');
                hamburger.setAttribute('aria-expanded', 'false');
                mobileNav.setAttribute('aria-hidden', 'true');
                document.body.style.overflow = '';
            }
        });
    }

    // 4. FAQ ACCORDION
    const faqItems = document.querySelectorAll('#faq .faq-item');
    faqItems.forEach(item => {
        const button = item.querySelector('.faq-question');
        const answer = item.querySelector('.faq-answer');

        if (button && answer) {
            button.addEventListener('click', () => {
                const isOpen = button.getAttribute('aria-expanded') === 'true';

                faqItems.forEach(otherItem => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('active');
                        const otherBtn = otherItem.querySelector('.faq-question');
                        const otherAns = otherItem.querySelector('.faq-answer');
                        if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
                        if (otherAns) otherAns.style.maxHeight = null;
                    }
                });

                if (isOpen) {
                    button.setAttribute('aria-expanded', 'false');
                    item.classList.remove('active');
                    answer.style.maxHeight = null;
                } else {
                    button.setAttribute('aria-expanded', 'true');
                    item.classList.add('active');
                    answer.style.maxHeight = answer.scrollHeight + 'px';
                }
            });
        }
    });

    // 5. MÁSCARA DE TELEFONE
    const phoneInput = document.getElementById('telefone');
    if (phoneInput) {
        phoneInput.addEventListener('input', (e) => {
            let value = e.target.value.replace(/\D/g, '');

            if (value.length > 11) {
                value = value.slice(0, 11);
            }

            if (value.length > 10) {
                value = value.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
            } else if (value.length > 6) {
                value = value.replace(/^(\d{2})(\d{4})(\d{0,4})$/, '($1) $2-$3');
            } else if (value.length > 2) {
                value = value.replace(/^(\d{2})(\d{0,5})$/, '($1) $2');
            } else if (value.length > 0) {
                value = value.replace(/^(\d*)$/, '($1');
            }

            e.target.value = value;
        });
    }

    // 6. FORMULÁRIO DE CONTATO (AJAX)
    const form = document.getElementById('custom-contact-form') || document.getElementById('contato-form');
    const responseContainer = document.getElementById('form-response');

    if (form) {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            if (responseContainer) {
                responseContainer.textContent = 'Enviando...';
                responseContainer.style.color = '';
            }

            const formData = new FormData(form);

            try {
                const response = await fetch(form.action || window.location.href, {
                    method: 'POST',
                    body: formData
                });

                const result = await response.json();

                if (responseContainer) {
                    if (result.success) {
                        responseContainer.style.color = 'green';
                        responseContainer.textContent = result.data;
                        form.reset();
                    } else {
                        responseContainer.style.color = 'red';
                        responseContainer.textContent = result.data;
                    }
                }
            } catch (error) {
                if (responseContainer) {
                    responseContainer.style.color = 'red';
                    responseContainer.textContent = 'Erro ao enviar. Tente novamente.';
                }
            }
        });
    }

    // 7. ACTIVE NAV LINK ON SCROLL
    const sections = document.querySelectorAll('section[id]');
    const navLinks = document.querySelectorAll('.nav a');

    function updateActiveNav() {
        if (!header) return;
        const scrollY = window.scrollY + header.offsetHeight + 100;

        sections.forEach(function (section) {
            const sectionTop = section.offsetTop;
            const sectionBottom = sectionTop + section.offsetHeight;
            const sectionId = section.getAttribute('id');

            if (scrollY >= sectionTop && scrollY < sectionBottom) {
                navLinks.forEach(function (link) {
                    link.style.color = '';
                    if (link.getAttribute('href') === '#' + sectionId) {
                        link.style.color = 'var(--color-gold)';
                    }
                });
            }
        });
    }

    window.addEventListener('scroll', updateActiveNav, { passive: true });   

    // 8. BOTÃO WHATSAPP FLUTUANTE
    const whatsappBtn = document.getElementById('whatsapp-btn');
    let whatsappVisible = false;

    function checkWhatsapp() {
        if (!whatsappBtn) return;
        if (window.scrollY > 300 && !whatsappVisible) {
            whatsappBtn.classList.add('visible');
            whatsappVisible = true;
        } else if (window.scrollY <= 300 && whatsappVisible) {
            whatsappBtn.classList.remove('visible');
            whatsappVisible = false;
        }
    }

    window.addEventListener('scroll', checkWhatsapp, { passive: true });

    // 9. CARROSSEL DE DEPOIMENTOS
    const wrapper = document.querySelector('.carousel-wrapper');
    const track = document.getElementById('carousel-track');
    const dotsContainer = document.getElementById('carousel-dots');
    const prevBtn = document.querySelector('.carousel-prev');
    const nextBtn = document.querySelector('.carousel-next');

    if (wrapper && track) {
        const cards = Array.from(track.querySelectorAll('.depoimento-card'));
        const totalCards = cards.length;
        const MOBILE_BREAKPOINT = 768;

        let itemsPerView = 1;
        let totalPages = 1;
        let currentPage = 0;
        let resizeTimeout = null;

        function getItemsPerView() {
            return window.innerWidth < MOBILE_BREAKPOINT ? 1 : 2;
        }

        function buildDots() {
            if (!dotsContainer) return;
            dotsContainer.innerHTML = '';
            for (let i = 0; i < totalPages; i++) {
                const dot = document.createElement('button');
                dot.type = 'button';
                dot.classList.add('carousel-dot');
                if (i === currentPage) dot.classList.add('active');
                dot.dataset.index = String(i);
                dot.setAttribute('aria-label', `Ir para o grupo de depoimentos ${i + 1}`);
                dot.addEventListener('click', () => goToPage(i));
                dotsContainer.appendChild(dot);
            }
        }

        function updateDots() {
            if (!dotsContainer) return;
            const dots = dotsContainer.querySelectorAll('.carousel-dot');
            dots.forEach((dot, i) => dot.classList.toggle('active', i === currentPage));
        }

        function updateTrackPosition() {
            const offset = currentPage * wrapper.offsetWidth;
            track.style.transform = `translateX(-${offset}px)`;
        }

        function goToPage(index) {
            if (totalPages <= 1) return;
            currentPage = (index + totalPages) % totalPages;
            updateTrackPosition();
            updateDots();
        }

        function nextPage() {
            goToPage(currentPage + 1);
        }

        function prevPage() {
            goToPage(currentPage - 1);
        }

        function recalc() {
            const newItemsPerView = getItemsPerView();
            const changedLayout = newItemsPerView !== itemsPerView;

            itemsPerView = newItemsPerView;
            totalPages = Math.max(1, Math.ceil(totalCards / itemsPerView));

            if (currentPage > totalPages - 1) {
                currentPage = totalPages - 1;
            }

            if (changedLayout) {
                buildDots();
            } else {
                updateDots();
            }

            requestAnimationFrame(updateTrackPosition);
        }

        function handleResize() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(recalc, 150);
        }

        if (prevBtn) prevBtn.addEventListener('click', prevPage);
        if (nextBtn) nextBtn.addEventListener('click', nextPage);
        window.addEventListener('resize', handleResize);

        // Init Carousel
        itemsPerView = getItemsPerView();
        totalPages = Math.max(1, Math.ceil(totalCards / itemsPerView));
        buildDots();
        requestAnimationFrame(updateTrackPosition);
    }

    // 10. GSAP & SCROLLTRIGGER
    function waitForGSAP(callback) {
        if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
            callback();
        } else {
            setTimeout(function () { waitForGSAP(callback); }, 50);
        }
    }

    waitForGSAP(function () {
        gsap.registerPlugin(ScrollTrigger);

        // Hero
        const heroTl = gsap.timeline({ delay: 0.3 });
        heroTl
            .fromTo('.hero-badge', { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out' })
            .fromTo('.hero-title', { opacity: 0, y: 50, clipPath: 'inset(0 0 100% 0)' }, { opacity: 1, y: 0, clipPath: 'inset(0 0 0% 0)', duration: 1, ease: 'power4.out' }, '-=0.3')
            .fromTo('.hero-subtitle', { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, '-=0.5')
            .fromTo('.hero-ctas', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out' }, '-=0.4');

        // Scroll Indicator
        const scrollIndicator = document.getElementById('scroll-indicator');
        if (scrollIndicator) {
            gsap.to(scrollIndicator, {
                y: 10,
                duration: 1.2,
                ease: 'sine.inOut',
                yoyo: true,
                repeat: -1
            });

            ScrollTrigger.create({
                start: '200px top',
                onEnter: function () {
                    gsap.to(scrollIndicator, { opacity: 0, duration: 0.3 });
                },
                onLeaveBack: function () {
                    gsap.to(scrollIndicator, { opacity: 1, duration: 0.3 });
                }
            });
        }

        // Sobre
        ScrollTrigger.create({
            trigger: '#sobre',
            start: 'top 85%',
            onEnter: function () {
                gsap.fromTo('#sobre .sobre-text .section-label', { x: -30, opacity: 0 }, { x: 0, opacity: 1, duration: 0.6, ease: 'power3.out' });
                gsap.fromTo('#sobre .gsap-fade-up', { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out', stagger: 0.15, delay: 0.1 });
                gsap.fromTo('#sobre .gsap-fade-in', { opacity: 0, scale: 0.97 }, { opacity: 1, scale: 1, duration: 1, ease: 'power3.out', delay: 0.2 });
            }
        });

        // Diferenciais
        ScrollTrigger.create({
            trigger: '#diferenciais',
            start: 'top 80%',
            onEnter: function () {
                gsap.fromTo('#diferenciais .section-label, #diferenciais .section-title, #diferenciais .section-subtitle', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7, stagger: 0.1, ease: 'power3.out' });
                gsap.fromTo('.diferencial-card', { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out', stagger: 0.1, delay: 0.3 });
            }
        });

        // Espaços
        ScrollTrigger.create({
            trigger: '#espacos',
            start: 'top 85%',
            onEnter: function () {
                gsap.fromTo('#espacos .section-label, #espacos .section-title, #espacos .section-subtitle', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7, stagger: 0.1, ease: 'power3.out' });
                gsap.fromTo('.espaco-card', { y: 60, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out', stagger: 0.15, delay: 0.2 });
            }
        });

        // Como Funciona
        ScrollTrigger.create({
            trigger: '#como-funciona',
            start: 'top 80%',
            onEnter: function () {
                gsap.fromTo('#como-funciona .section-label, #como-funciona .section-title, #como-funciona .section-subtitle', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7, stagger: 0.1, ease: 'power3.out' });
                gsap.fromTo('.step-card', { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7, ease: 'back.out(1.2)', stagger: 0.15, delay: 0.3 });
            }
        });

        // Galeria
        ScrollTrigger.create({
            trigger: '#galeria',
            start: 'top 80%',
            onEnter: function () {
                gsap.fromTo('#galeria .section-label, #galeria .section-title', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7, stagger: 0.1, ease: 'power3.out' });
                gsap.fromTo('.galeria-item', { opacity: 0, scale: 0.95 }, { opacity: 1, scale: 1, duration: 0.7, ease: 'power3.out', stagger: 0.1, delay: 0.2 });
            }
        });

        // Números
        ScrollTrigger.create({
            trigger: '#numeros',
            start: 'top 75%',
            onEnter: function () {
                gsap.fromTo('#numeros .section-label, #numeros .section-title', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7, stagger: 0.1, ease: 'power3.out' });
                gsap.fromTo('.numero-item', { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out', stagger: 0.12, delay: 0.2 });

                const counters = document.querySelectorAll('.numero-value[data-target]');
                counters.forEach(function (counter) {
                    const target = parseInt(counter.dataset.target);
                    const suffix = counter.dataset.suffix || '';
                    const prefix = counter.dataset.prefix || '';
                    const isFormatted = counter.dataset.format === 'true';

                    gsap.to({ value: 0 }, {
                        value: target,
                        duration: 2.5,
                        delay: 0.4,
                        ease: 'power2.out',
                        onUpdate: function () {
                            const currentValue = Math.round(this.targets()[0].value);
                            const displayValue = isFormatted ? currentValue.toLocaleString('pt-BR') : currentValue;
                            counter.textContent = prefix + displayValue + suffix;
                        }
                    });
                });
            }
        });

        // Médicos
        ScrollTrigger.create({
            trigger: '#medicos',
            start: 'top 80%',
            onEnter: function () {
                gsap.fromTo('#medicos .section-label, #medicos .section-title, #medicos .section-subtitle', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7, stagger: 0.1, ease: 'power3.out' });
                gsap.fromTo('.medico-card', { y: 60, opacity: 0 }, { y: 0, opacity: 1, duration: 0.9, ease: 'power3.out', stagger: 0.2, delay: 0.3 });
            }
        });

        // Depoimentos
        ScrollTrigger.create({
            trigger: '#depoimentos',
            start: 'top 80%',
            onEnter: function () {
                gsap.fromTo('#depoimentos .section-label, #depoimentos .section-title, #depoimentos .section-subtitle', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7, stagger: 0.1, ease: 'power3.out' });
                gsap.fromTo('.carousel-wrapper', { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 0.9, ease: 'power3.out', delay: 0.3 });
            }
        });

        // FAQ
        ScrollTrigger.create({
            trigger: '#faq',
            start: 'top 80%',
            onEnter: function () {
                gsap.fromTo('#faq .section-label, #faq .section-title, #faq .section-subtitle', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7, stagger: 0.1, ease: 'power3.out' });
                gsap.fromTo('.faq-item', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6, ease: 'power3.out', stagger: 0.08, delay: 0.2 });
            }
        });

        // Contato
        ScrollTrigger.create({
            trigger: '#contato',
            start: 'top 80%',
            onEnter: function () {
                gsap.fromTo('.contato-text', { x: -40, opacity: 0 }, { x: 0, opacity: 1, duration: 0.9, ease: 'power3.out' });
                gsap.fromTo('.form-card', { x: 40, opacity: 0 }, { x: 0, opacity: 1, duration: 0.9, ease: 'power3.out', delay: 0.15 });
            }
        });

        // Footer
        ScrollTrigger.create({
            trigger: '#footer',
            start: 'top 90%',
            onEnter: function () {
                gsap.fromTo('.footer-grid > *', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6, ease: 'power3.out', stagger: 0.1 });
            }
        });

        // Hero Parallax
        gsap.to('.hero-bg img', {
            yPercent: 25,
            ease: 'none',
            scrollTrigger: {
                trigger: '#hero',
                start: 'top top',
                end: 'bottom top',
                scrub: true
            }
        });

        // Refresh pós-load para precisão de posições
        ScrollTrigger.refresh();
    });

    window.addEventListener('load', function () {
        if (typeof ScrollTrigger !== 'undefined') {
            ScrollTrigger.refresh();
        }
    });
});